import { render } from "./Text.vue?vue&type=template&id=64701e30&scoped=true"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"

import "./Text.vue?vue&type=style&index=0&id=64701e30&lang=scss&scoped=true"

import exportComponent from "/Users/wojciechkasprzak/WWW/ilona-michal-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64701e30"]])

export default __exports__